import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function ServiceArea() {
  return <section className="py-20 bg-white" data-id="element-132">
      <div className="container mx-auto px-4" data-id="element-133">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-134">
          <div className="lg:w-1/2" data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-136">
              Nationwide UK Coverage
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8" data-id="element-137">
              Our logistics network allows us to deliver anywhere across the
              United Kingdom, ensuring fast response times and dependable
              service wherever you are.
            </p>

            <div className="grid grid-cols-2 gap-4" data-id="element-138">
              {['London', 'Manchester', 'Birmingham', 'Glasgow', 'Edinburgh', 'Cardiff', 'Belfast', 'Newcastle'].map(city => <div key={city} className="flex items-center text-slate-700" data-id="element-139">
                  <MapPinIcon className="h-5 w-5 text-primary mr-2" data-id="element-140" />
                  <span data-id="element-141">{city}</span>
                </div>)}
            </div>
          </div>

          <div className="lg:w-1/2 w-full flex justify-center" data-id="element-142">
            {/* Stylized Map Placeholder */}
            <div className="relative w-full max-w-md aspect-[3/4] bg-blue-50 rounded-3xl border border-blue-100 flex items-center justify-center p-8" data-id="element-143">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, #2563EB 1px, transparent 0)',
              backgroundSize: '24px 24px'
            }} data-id="element-144"></div>

              {/* Map Pins */}
              <div className="absolute top-[20%] right-[40%] animate-bounce" style={{
              animationDelay: '0ms'
            }} data-id="element-145">
                <MapPinIcon className="h-8 w-8 text-primary drop-shadow-md" data-id="element-146" />
              </div>
              <div className="absolute top-[40%] left-[30%] animate-bounce" style={{
              animationDelay: '200ms'
            }} data-id="element-147">
                <MapPinIcon className="h-6 w-6 text-slate-800 drop-shadow-md" data-id="element-148" />
              </div>
              <div className="absolute top-[60%] right-[30%] animate-bounce" style={{
              animationDelay: '400ms'
            }} data-id="element-149">
                <MapPinIcon className="h-7 w-7 text-primary drop-shadow-md" data-id="element-150" />
              </div>
              <div className="absolute bottom-[25%] left-[45%] animate-bounce" style={{
              animationDelay: '600ms'
            }} data-id="element-151">
                <MapPinIcon className="h-8 w-8 text-slate-800 drop-shadow-md" data-id="element-152" />
              </div>

              <div className="text-center relative z-10 bg-white/80 backdrop-blur px-6 py-4 rounded-xl shadow-sm border border-white" data-id="element-153">
                <p className="font-bold text-slate-900" data-id="element-154">100% UK Coverage</p>
                <p className="text-sm text-slate-600" data-id="element-155">
                  From Highlands to Cornwall
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}